import React, { useState } from "react"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import "../../styles/layouts"
import * as styles from "./Styles/Agreement.module.scss"
import { RequestHandler } from "../Utils/request_handler"
import Sentry from "../Common/Sentry"

const Agreement = (props) => {
  const [termsAccepted, setTermsAccepted] = useState(props.accepted)
  const onTermsAccepted = async (e) => {
    try {
      const handler = new RequestHandler("/admin/terms_accept", "PUT", {
        accept_editor_term: true,
      })
      const res = await handler.request()
      if (res.status == 200) {
        setTermsAccepted(true)
      } else {
        handleError(undefined)
      }
    } catch (e) {
      handleError(e)
    }
  }
  const handleError = (e) => {
    if (e) {
      Sentry.captureException(e)
    }
    alert(
      "通信に失敗しました。解消されない場合は、事務局までお問い合わせください。"
    )
  }

  return (
    <Modal show={!termsAccepted}>
      <Modal.Header>
        <Modal.Title>ロコガイド情報配信サービス利用規約</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        サービスのご利用には、
        <a
          href="https://locoguide.jp/services/assets/pdf/terms_of_service.pdf"
          target="_blank"
          className={styles.link}
        >
          利用規約
        </a>
        にご同意いただく必要があります。
      </Modal.Body>
      <Modal.Footer>
        <Button className="l-primary-button--admin" onClick={onTermsAccepted}>
          同意して利用を開始する
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default Agreement
